import * as React from 'react';
import { ClipboardList } from 'lucide-react';
import { useTranslation } from 'react-i18next';

import { ORDER_UPDATE_FIELD_CATEGORY, type Order } from '@klareospace/pharos-lib-types';
import { DrawerSection } from '@klareospace/pharos-lib-web-utils';

import { useOrderEditability } from '../hooks/use-order-editability';
import { InstructionInlineEditor } from './instruction-inline-editor';

// ─── Types ────────────────────────────────────────────────────────────────────

export interface InstructionSectionProps {
  readonly order: Order;
}

// ─── Component ────────────────────────────────────────────────────────────────

/**
 * Always-rendered, full-width section for the order's free-text instruction — kept as its
 * own DrawerSection (rather than a row inside ContentSummarySection) since the field is
 * long-form text that needs the full card width to wrap without clamping.
 */
export function InstructionSection({ order }: InstructionSectionProps): React.JSX.Element {
  const { t } = useTranslation('orders');
  const { getFieldState, lockReason } = useOrderEditability(order);
  const fieldState = getFieldState(ORDER_UPDATE_FIELD_CATEGORY.NON_IMPACTING);

  return (
    <DrawerSection icon={ClipboardList} title={t('common.instruction')}>
      <InstructionInlineEditor fieldState={fieldState} lockReason={lockReason} order={order} />
    </DrawerSection>
  );
}
